<script lang="ts">
  /** 暗記事項（lesson-format.md §7.4）: memo カードを title・statement・snippet・why の順に並べる */
  import CodeBlock from '../CodeBlock.svelte';
  import InlineMarkdown from '../InlineMarkdown.svelte';
  import type { MemoCard } from './types';

  interface Props {
    memos: readonly MemoCard[];
  }

  let { memos }: Props = $props();
</script>

<ul class="memos" data-testid="memo-list">
  {#each memos as m (m.id)}
    <li class="memo" data-memo-id={m.id}>
      <h3>{m.title}</h3>
      <div class="statement"><InlineMarkdown text={m.statement} block /></div>
      {#if m.snippet}
        <CodeBlock code={m.snippet.replace(/\n$/, '')} label="{m.title} のコード" />
      {/if}
      {#if m.why}
        <div class="why">
          <span class="eyebrow">理由</span>
          <InlineMarkdown text={m.why} block />
        </div>
      {/if}
    </li>
  {/each}
</ul>

<style>
  .memos {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
  }
  .memo {
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
    padding: var(--space-4);
    border: 1px solid var(--border);
    border-left: 4px solid var(--accent);
    border-radius: var(--radius-md);
    background: var(--surface);
    min-width: 0;
  }
  .memo h3 {
    font-size: var(--fs-md);
  }
  .why {
    font-size: var(--fs-sm);
    color: var(--text-soft);
  }
  .why .eyebrow {
    display: block;
    margin-bottom: var(--space-1);
  }
</style>
